/** One emoji grapheme: pictographs, flags, skin tones, ZWJ sequences. */
const EMOJI_GRAPHEME =
  /^(?=.*(?:\p{Extended_Pictographic}|\p{Regional_Indicator}))(?:\p{Extended_Pictographic}|\p{Emoji_Component}|‍|️)+$/u;

/** Up to this many emoji alone in a message show big, like WhatsApp. */
export const JUMBO_EMOJI_MAX = 3;

/**
 * How many emoji a message is made of when it's nothing else (spaces aside)
 * and at most JUMBO_EMOJI_MAX of them; 0 otherwise — drawn as normal text.
 */
export const jumboEmojiCount = (body: string | null | undefined): number => {
  const text = body?.replace(/\s+/g, "") ?? "";
  if (!text) return 0;
  const graphemes = [...new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(text)];
  if (graphemes.length > JUMBO_EMOJI_MAX) return 0;
  return graphemes.every((g) => EMOJI_GRAPHEME.test(g.segment)) ? graphemes.length : 0;
};

/** [insert] typed over the selection start..end; where the caret lands. */
export const insertAtSelection = (text: string, start: number, end: number, insert: string) => ({
  text: text.slice(0, start) + insert + text.slice(end),
  caret: start + insert.length,
});
